import React from "react";
import ProductCard from "./ProductCard";

export default function MasonryGrid({ products }) {
  if (!products?.length) {
    return (
      <p data-testid="empty-products" className="text-[#636769] text-sm">
        No products yet — check back soon.
      </p>
    );
  }
  return (
    <div
      data-testid="masonry-grid"
      className="columns-2 md:columns-3 xl:columns-4 gap-4 sm:gap-6"
    >
      {products.map((p) => (
        <ProductCard key={p.id} product={p} />
      ))}
    </div>
  );
}
